// Subscription Plans for S&T Brain Trainer
// PayPal-Links sind jetzt aktiv!

export const SUBSCRIPTIONS = [
  {
    id: 'klein',
    name: 'Kleines Abonnement',
    description: 'BQ + HQ Grundlagen',
    price: '89 €',
    priceValue: 89,
    schedule: 'Di–Do 19:00–21:00\nalle 2 Wochen Mo: BKW',
    features: [
      'BQ vollständig (alle Fächer)',
      'HQ Betriebliches Kostenwesen (Grundlagen)',
      'Alle Intensivkurse im Zeitraum enthalten'
    ],
    exclusions: [
      'HQ Technik nicht enthalten'
    ],
    paypalLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-7FE689231X6040324M454E5I',
    popular: false,
    buttonText: 'Abo starten'
  },
  {
    id: 'gross',
    name: 'Großes Abonnement',
    description: 'BQ + HQ komplett',
    price: '149 €',
    priceValue: 149,
    schedule: 'Di–Do 19:00–21:00\nalle 2 Wochen Mo: BKW',
    features: [
      'BQ vollständig (alle Fächer)',
      'HQ Betriebliches Kostenwesen komplett',
      'Alle Intensivkurse im Zeitraum enthalten',
      'Fachgesprächsvorbereitung'
    ],
    exclusions: [
      'HQ Technik nicht enthalten'
    ],
    paypalLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-4WU30009MM452994YM454L4Q',
    popular: true,
    buttonText: 'Abo starten'
  },
  {
    id: 'komplett',
    name: 'Komplettkurs Meister',
    description: 'Ratenzahlung über 13 Monate',
    price: '200 €',
    priceValue: 200,
    schedule: 'Di–Do 19:00–21:00\nalle 2 Wochen Mo: BKW',
    features: [
      'Alle Inhalte aus kleinem & großem Abo',
      'Alle Intensivkurse inklusive',
      'Begleitung bis zur Prüfung',
      'Ratenzahlung über 13 Monate'
    ],
    exclusions: [
      'HQ Technik separat'
    ],
    paypalLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-43U66170GK3880438M46RRQA',
    popular: false,
    buttonText: 'Jetzt starten'
  },
  {
    id: 'hq-technik',
    name: 'HQ Technik – fachspezifisch',
    description: 'Technische Fachrichtungen',
    price: '69 €',
    priceValue: 69,
    schedule: 'alle 2 Wochen Sonntag\n10:00–14:00 Uhr',
    features: [
      'Handlungsspezifische Qualifikation – Technik',
      'Betriebstechnik',
      'Fertigungstechnik',
      'Montagetechnik',
      'Immer separat buchbar'
    ],
    exclusions: [],
    paypalLink: 'https://www.paypal.com/webapps/billing/plans/subscribe?plan_id=P-6KB67878MY742411KNFCDADQ',
    popular: false,
    variant: 'tech',
    buttonText: 'HQ Technik abonnieren'
  }
];

export const SUPPORT_INFO = {
  title: 'S&T Brain Trainer',
  subtitle: 'Dein Weg zum Industriemeister',
  description: 'Professionelle Vorbereitung auf deine Meisterprüfung. Buche dein Abonnement und starte durch!',
  websiteUrl: 'https://www.stbrain-trainerimgbr.de/',
  websiteNote: 'Einzelbuchungen & Zusatzkurse sind nicht in der App buchbar',
  subjects: {
    bq: 'NTG · BWH · RBH · MiKP · ZIB',
    hq: 'Betriebliches Kostenwesen',
    hqTechnik: 'Betriebstechnik · Fertigungstechnik · Montagetechnik'
  },
  contact: {
    email: 'info@stbrain-trainer.de',
    website: 'https://www.stbrain-trainerimgbr.de/'
  },
  faq: [
    {
      question: 'Wie funktioniert die Buchung?',
      answer: 'Klicken Sie auf den gewünschten Button und Sie werden zu PayPal weitergeleitet. Nach erfolgreicher Zahlung erhalten Sie Zugang zu allen Kursmaterialien.'
    },
    {
      question: 'Was ist in den Abonnements enthalten?',
      answer: 'Je nach Paket erhalten Sie Zugang zu BQ/HQ Kursen, Intensivkursen, Fachgesprächen und persönlicher Betreuung. Details siehe oben bei den einzelnen Paketen.'
    },
    {
      question: 'Kann ich das Paket wechseln?',
      answer: 'Ja, Sie können jederzeit auf ein höheres Paket upgraden. Die Differenz wird angerechnet.'
    },
    {
      question: 'Wo finde ich Einzelbuchungen?',
      answer: 'Einzelbuchungen und Zusatzkurse sind nur über unsere Webseite möglich: www.stbrain-trainerimgbr.de'
    },
    {
      question: 'Ist HQ Technik separat?',
      answer: 'Ja, HQ Technik ist ein separates Modul und nicht in den anderen Abonnements enthalten. Sie können es jederzeit zusätzlich buchen.'
    }
  ]
};
